export const UserEmailStorageKey = 'TronLogo_User_Email';

// query param names
export const ReturnUrlQueryParam = 'returnUrl';

// base URLs
export const LogoUploadUrl = '/logo/upload';
export const LogoGalleryUrl = '/logo/gallery';
export const LogoEditorUrl = '/logo/editor';

// app events
export const onCloseEventName = 'on-close';



// WEBPACK FOOTER //
// ./src/App/shared/constants.tsx